export default __webpack_public_path__ + "static/media/course-progress.cb9d2d99.png";